import { Rate } from "../rate-type";
import { RateLocationMapper } from "./rate-location.mapper";
import { RateLocationBase } from "./rate-location-base.model";
import { Location } from "../../location/location.model";
import { RateLocation } from "./rate-location.type";
import { LocationMapper } from "../../location/location.mapper";
import { RateMapper } from "../rate.mapper";
import { ContainerPrices } from "../../shared/container/container-prices.model";

export class FclRateLocation extends RateLocationBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected location: Location,
    protected comment: string,
    protected rate: Rate,
    protected containers: ContainerPrices,
    protected parent: RateLocation,
    protected excludedOriginLocations: RateLocation[],
    protected excludedDestinationLocations: RateLocation[],
  ) {
    super(
      id,
      discriminator,
      location,
      comment,
      rate,
      parent,
      excludedOriginLocations,
      excludedDestinationLocations,
    );
  }

  public getContainers(): ContainerPrices {
    return this.containers;
  }

  public getClone(): RateLocation {
    return RateLocationMapper.map({
      id: this.getId(),
      discriminator: this.getDiscriminator(),
      comment: this.getComment(),
      containers: this.getContainers().getRequestParams(),
      location: LocationMapper.map(this.getLocation()),
      rate: RateMapper.map(this.getRate()),
      parent: this.getParent(),
      excludedOriginLocations: this.getExcludedOriginLocations(),
      excludedDestinationLocations: this.getExcludedDestinationLocations(),
    });
  }
}
